var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pie-echarts"},[_c('ve-ring',{attrs:{"data":_vm.optionData.data,"grid":_vm.optionData.grid,"legend":_vm.optionData.legend,"settings":_vm.optionData.settings,"theme":_vm.optionData.theme,"title":_vm.optionData.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }